import { useEffect, useState } from "react";

import utility from "core/Utils";
import IconInput from "components/elements/IconInput";
import Table from "components/elements/Table";
import Modal from "components/elements/Modal";
import Select from "components/elements/Select";

import { ReactComponent as EyeIcon } from "../../../images/eye.svg";
import { ReactComponent as DownloadIcon } from "../../../images/download.svg";

const headerMap = {
  type: "Type",
  status: "Status",
  count: "Count",
  action: "Action",
};

const FileDetailsOverview = props => {
  const [overviewData, setOverviewData] = useState([]);

  const [showColModal, setShowColModal] = useState(false);
  const [columns] = useState(utility.optionFromObject(headerMap));
  const [selectedColumns, setSelectedColumns] = useState(
    utility.optionFromObject(headerMap)
  );

  useEffect(() => {
    let overviewList = [];
    let data = [...props.data];

    for (let i = 0; i < data.length; i++) {
      // check if current type+status exists in overview list
      let index = -1;
      for (let j = 0; j < overviewList.length; j++) {
        if (
          overviewList[j].type === data[i].type &&
          overviewList[j].status === data[i].status
        ) {
          index = j;
          break;
        }
      }

      // if exists then increase count within that
      if (index > -1) {
        overviewList[index].count += 1;
      } else {
        overviewList.push({
          type: data[i].type,
          status: data[i].status,
          count: 1,
          action: (
            <div className="flex">
              <div
                className="action-button flex flex-center"
                title="view"
                onClick={() => {
                  props.showDetails({
                    type: data[i].type,
                    status: data[i].status,
                  });
                }}
              >
                <EyeIcon />
              </div>
            </div>
          ),
        });
      }
    }

    setOverviewData(overviewList);
  }, [props]);

  const colModal = (
    <Modal onClose={() => setShowColModal(false)}>
      <h3>Select Columns</h3>
      <div className="full-row" style={{ width: "50vw", marginTop: "2rem" }}>
        <Select
          isMulti
          value={selectedColumns}
          options={columns}
          placeholder="Select columns to show"
          onChange={val => setSelectedColumns(val)}
        />
      </div>
    </Modal>
  );

  return (
    <div className="results-wrapper flex-full">
      {showColModal && colModal}
      <div className="head flex flex-v-center">
        <h3>Results</h3>
        <div className="right">
          <div className="flex flex-v-center">
            <div className="el">
              <input
                type="text"
                readOnly
                placeholder="Select Columns"
                onClick={e => {
                  e.preventDefault();
                  setShowColModal(true);
                }}
              />
            </div>
            <div className="el">
              <IconInput placeholder="Search" icon="search" />
            </div>
          </div>
        </div>
      </div>
      <div className="results">
        <Table
          headers={utility.objectFromOptions(selectedColumns)}
          data={overviewData}
        />
      </div>
    </div>
  );
};

export default FileDetailsOverview;
